import { CatalogSection } from "@client/components/home/CatalogSection";
import { FaqSection } from "@client/components/home/FaqSection";
import { FeaturedSection } from "@client/components/home/FeaturedSection";
import { HomeHero } from "@client/components/home/HomeHero";
import { LatestArticlesSection } from "@client/components/home/LatestArticlesSection";
import { TopicsBento } from "@client/components/home/TopicsBento";
import { PageMeta } from "@client/components/seo/PageMeta";
import { SectionDivider } from "@client/components/ui/SectionDivider";

export function HomePage() {
  return (
    <main>
      <PageMeta path="/" />
      <HomeHero />
      <FeaturedSection />
      <CatalogSection />
      <SectionDivider />
      <TopicsBento />
      <SectionDivider />
      <LatestArticlesSection />
      <SectionDivider />
      <FaqSection />
    </main>
  );
}
